<mat-card class="cardWithShadow">
  <mat-card-header style="align-items: baseline; padding: 24px 24px 0 24px;">
    <div style="display: flex; align-items: baseline; gap: 16px; flex-wrap: wrap;">
      
      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 280px;">
        <mat-label>Buscar Solicitud</mat-label>
        <input matInput (keyup)="applyFilter()" placeholder="Buscar por cliente, local, ticket..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;" *ngIf="isGruman">
        <mat-label>Filtrar Cliente</mat-label>
        <mat-select [(value)]="selectedClientId" (selectionChange)="onClientFilterChange()">
          <mat-option [value]="null">Todos los clientes</mat-option>
          @for (cliente of clientes; track cliente.id) {
            <mat-option [value]="cliente.id">{{ cliente.nombre }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 120px;">
        <mat-label>Mes</mat-label>
        <mat-select [(value)]="selectedMes" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (mes of meses; track mes) {
            <mat-option [value]="mes">{{ mes }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 100px;">
        <mat-label>Año</mat-label>
        <mat-select [(value)]="selectedAnio" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (anio of anios; track anio) {
            <mat-option [value]="anio.toString()">{{ anio }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;">
        <mat-label>Tipo de Servicio</mat-label>
        
        <mat-select [(value)]="selectedServiceType" (selectionChange)="onServiceTypeChange()">
          
          <mat-select-trigger>
            @if (selectedServiceType) {
              <app-service-badge [label]="selectedServiceType"></app-service-badge>
            } @else {
              Todos los servicios
            }
          </mat-select-trigger>

          <mat-option value="">Todos los servicios</mat-option>
          
          @for (tipo of tiposServicio; track tipo.id) {
            <mat-option [value]="tipo.nombre"> 
              <app-service-badge [label]="tipo.nombre"></app-service-badge>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button mat-icon-button type="button" color="primary" (click)="resetFilters()" matTooltip="Limpiar filtros" style="top: 6px;">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div style="flex: 1 1 auto;"></div>
    
    <div style="display: flex; align-items: center; gap: 8px;">
      <button mat-stroked-button color="primary" (click)="exportarExcel()">
        <mat-icon>file_download</mat-icon> Exportar
      </button>
    </div>
  </mat-card-header>
    
  <mat-card-content class="p-24">
    <!-- Indicador de carga -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Cargando solicitudes...</p>
    </div>

    <!-- Mensaje cuando no hay datos -->
    <div *ngIf="dataSource.data.length === 0" class="no-data-message">
      <mat-icon>event_busy</mat-icon>
      <p>No hay solicitudes finalizadas para mostrar</p>
    
      <p class="text-muted">Las solicitudes finalizadas aparecerán aquí cuando estén disponibles</p>
    </div>

    <!-- Tabla con datos -->
    <div class="table-responsive m-t-16" [hidden]="loading">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>N° Ticket</th>
          <td mat-cell *matCellDef="let row">{{row.id}}</td>
        </ng-container>

      <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
          <td mat-cell *matCellDef="let row">{{row.client?.nombre || 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="local">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Local</th>
          <td mat-cell *matCellDef="let row">{{row.local?.nombre_local || 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="zona">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Zona </th>
            <td mat-cell *matCellDef="let element" class="f-s-14"> 
              <span class="p-x-8 p-y-4 bg-light-primary rounded f-w-600 text-primary f-s-12">
                {{ element.zona }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="especialidad">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Especialidad </th>
            <td mat-cell *matCellDef="let element" class="f-s-14"> {{ element.especialidad_nombre }} </td>
          </ng-container>

        <ng-container matColumnDef="fechaIngreso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Ingreso</th>
          <td mat-cell *matCellDef="let row">{{row.fechaIngreso | date:'dd/MM/yyyy'}}</td>
        </ng-container>

        <ng-container matColumnDef="ticketGruman">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>IDTicket Cliente</th>
          <td mat-cell *matCellDef="let row">{{row.ticketGruman || 'Sin ticket'}}</td>
        </ng-container>
        
        <ng-container matColumnDef="generado_por">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Generado por</th>
            <td mat-cell *matCellDef="let row">{{row.generada_por ? (row.generada_por.name + ' ' + row.generada_por.lastName) : 'Sin usuario'}}</td>
        </ng-container>

        <ng-container matColumnDef="tipoServicio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoServicio.nombre">
            Tipo de Servicio
          </th>
          <td mat-cell *matCellDef="let row">
            <app-service-badge [label]="row?.tipoServicio?.nombre"></app-service-badge>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipo_solicitud">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipo_solicitud.nombre">Tipo Solicitud</th>
          <td mat-cell *matCellDef="let row">{{ row?.tipo_solicitud?.nombre || '' }}</td>
        </ng-container>

        <ng-container matColumnDef="observaciones">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Observaciones</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.observaciones">{{ row.observaciones?.length > 50 ? (row.observaciones | slice:0:50) + '...' : row.observaciones }}</td>
        </ng-container>

        <ng-container matColumnDef="tecnico">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Técnico</th>
            <td mat-cell *matCellDef="let row">{{row.tecnico_asignado ? (row.tecnico_asignado.name + ' ' + row.tecnico_asignado.lastName) : 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let row">
            <!-- CR-202608-0036 - Mostrar botón amarillo "Reabierto" cuando el estado de la solicitud sea 'reabierta' -->
            <button mat-raised-button 
                    *ngIf="!isReadOnly && row.status === 'reabierta'"
                    style="background-color: #ffb300; color: #ffffff;"
                    (click)="finalizarSolicitud(row)" 
                    [disabled]="!canViewDetail(row)"
                    matTooltip="Ver y gestionar ticket reabierto">
              <mat-icon>rotate_right</mat-icon>
              Reabierto
            </button>

            <!-- CR-202608-0036 - Mostrar botón azul "Validar" únicamente para solicitudes en estado 'finalizada' -->
            <button mat-raised-button color="primary" 
                    *ngIf="!isReadOnly && row.status !== 'reabierta' && canViewDetail(row)"
                    (click)="finalizarSolicitud(row)" 
                    matTooltip="Validar y cerrar solicitud">
              <mat-icon>check_circle</mat-icon>
              Validar
            </button>
          </td>
        </ng-container>

          <!-- PDF Column -->
          <!-- <ng-container matColumnDef="pdf">
            <th mat-header-cell *matHeaderCellDef>PDF</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button color="primary" 
                      (click)="$event.stopPropagation(); downloadPdf(row)"
                      matTooltip="Descargar PDF">
                <mat-icon>picture_as_pdf</mat-icon>
              </button>
            </td>
          </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="no-data-message">
              <mat-icon>search_off</mat-icon>
              <p>No se encontraron coincidencias para "{{input.value}}"</p>
              <p class="text-muted">Intenta con otros términos de búsqueda</p>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="paginator-container" [hidden]="loading">
      <mat-paginator
        [length]="totalItems"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card> 